import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

import { UtilPipesModule } from '@core/shared/util';

@Component({
  selector: 'mp-zendesk-help-center-article-card',
  templateUrl: './zendesk-help-center-article-card.component.html',
  styleUrl: './zendesk-help-center-article-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatAnchor, MatIcon, UtilPipesModule],
})
export class ZendeskHelpCenterArticleCardComponent {
  readonly articleTitle: InputSignal<string> = input.required<string>();

  readonly articleHTMLDescription: InputSignal<string> = input.required<string>();

  readonly articleLink: InputSignal<string> = input.required<string>();
}
